/**
 * HTTPヘッダーからUserAgent情報関連関数を管理する。
 */
const REGEX_IPAD_OS_VERSION = /ipad; cpu os (.+?) like/;

export const SCREEN_ROTATION_IOS_VERSION_UPPER = 13;

/**
 * iOSバージョンリスト
 * ※「.」区切りで設定すること
 */
export const IOS_VERSIONS = {
  V_11_2_5: '11.2.5',
  V_12_1: '12.1',
  V_12_4: '12.4',
  V_14_2: '14.2',
  V_15_1: '15.1',
  V_15_6: '15.6',
  V_16_1_1: '16.1.1',
  CHARTJS_IOS_VERSION_UNDER: '13.4',
} as const;
export type IOSVersions = typeof IOS_VERSIONS[keyof typeof IOS_VERSIONS];

/**
 * ユーザーエージェント情報を取得する。
 * @returns user-agent文字列
 */
export const getUserAgent = (): string => {
  return navigator.userAgent || '';
};

/**
 * iOSバージョン取得
 * @param userAgent
 * @returns iOSバージョン
 */
export const getIOSVersion = (userAgent: string): string | undefined => {
  const _versionArray = userAgent.toLowerCase().match(REGEX_IPAD_OS_VERSION);
  return _versionArray && _versionArray.length > 1 ? _versionArray[1].split('_').join('.') : undefined;
};

/**
 * iOSバージョン(メジャーナンバー)取得
 * @param userAgent
 * @returns iOSバージョン
 */
export const getIOSVersionMajorNumber = (userAgent: string): number | undefined => {
  const _version = getIOSVersion(userAgent);
  const _versionNumberArray = _version ? _version.split('.') : undefined;
  return _versionNumberArray && _versionNumberArray.length > 0 ? Number(_versionNumberArray[0]) : undefined;
};

/**
 * iOSバージョン(メジャー番号.マイナー番号1番目まで)で利用可能バージョンか確認
 * iOSバージョンが取得できない環境(iPad以外のデスクトップなど)は利用可能とする
 * @param iOSVersion 基準iOSバージョン
 * @returns 判定;(iOSバージョンが取得できない環境(iPad以外のデスクトップなど)は利用可能とする)
 */
export const isAvailableIOSVersion = (iOSVersion: IOSVersions): boolean => {
  const _currentVersion = getIOSVersion(getUserAgent());
  if (!_currentVersion) return true;
  const _versionNumberArray = iOSVersion.split('.');
  const _currentVersionNumberArray = _currentVersion.split('.');
  let judge = true;
  _versionNumberArray.forEach((_eachNum: string, index: number) => {
    const _currentEachNum = Number(_currentVersionNumberArray[index]) || 0;
    if (_currentEachNum > Number(_eachNum)) {
      judge = true;
      return;
    } else if (_currentEachNum < Number(_eachNum)) {
      judge = false;
      return;
    }
  });

  return judge;
};
